import { Badge } from '@mogzo/ui';
import { Link } from 'react-router';

/** Logo, wordmark and the yellow DEVELOPERS label, at the top of the sidebar. */
export function Brand() {
  return (
    <Link to="/" aria-label="MOGZO developers home" className="mz-sidebar-brand">
      <img src="/brand/mascot.svg" alt="" width={24} height={25} />
      <span className="mz-wordmark">mogzo</span>
      <Badge tone="brand">DEVELOPERS</Badge>
    </Link>
  );
}
